import { GetLockerOrdersState } from './getLockerOrders.types'

const getLockerOrdersInitialState: GetLockerOrdersState = {
  loading: false,
  error: null,
  success: null,
  currentRequestId: null
}

export default getLockerOrdersInitialState
